<script lang="ts">
  import GetFolderName from './GetFolderName.svelte';
  import AddFiles from './AddFiles.svelte';
  import ModalEvent from '$shared/constants/ModalEvent';

  const Steps = {
    step1: 'add-folder-name',
    step2: 'add-files'
  };

  interface Props {
    error?: string;
    onevent?: (payload: any) => void;
  }

  let { error = '', onevent }: Props = $props();

  let folderName = $state('');
  let files: File[] = $state([]);
  let activeStep = $state(Steps.step1);

  const onClickNext = (newFolderName: string): void => {
    folderName = newFolderName || '';
    activeStep = Steps.step2;
  };

  const onClickClose = (): void => {
    onevent?.({ type: ModalEvent.close });
  };

  const onClickGoBack = (): void => {
    activeStep = Steps.step1;
  };

  const onFilesClickChange = (newFiles: File[]): void => {
    files = newFiles;
  };

  const onClickSave = (newFiles: File[]): void => {
    files = newFiles;
    onevent?.({ type: ModalEvent.ok, data: { folderName, files } });
  };

  const clearError = (): void => {
    onevent?.({ type: ModalEvent.closeError });
  };
</script>

<div class="doc-new-folder" data-cy="doc-new-folder">
  {#if activeStep === Steps.step2}
    <AddFiles
      {error}
      {folderName}
      values={files}
      oncancel={onClickGoBack}
      oncloseerror={clearError}
      onsave={onClickSave}
      onchange={onFilesClickChange}
    />
  {:else}
    <GetFolderName
      {error}
      value={folderName}
      oncloseerror={clearError}
      onnext={onClickNext}
      oncancel={onClickClose}
    />
  {/if}
</div>

<style>
  .doc-new-folder {
    padding: 24px;
    width: 450px;
  }
</style>
